module.exports = __webpack_public_path__ + "img/yellow.43630d88.svg";